/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_RangeInputs */



/**
* | output |
* | --- |
* | "Event Range" |
*
* @param {Event_RangeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_range = /** @type {((inputs?: Event_RangeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_RangeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plage d’événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veranstaltungsbereich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Intervallo di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Диапазон событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rango de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件范围")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント範囲")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटना सीमा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Faixa de eventos")
	return /** @type {LocalizedString} */ ("Event Range")
});